<template>
  <!-- 套餐商品详情 -->
  <div class="Package-goods" v-if="bodyShow">
    <div class="header">
      <!-- banner -->
      <img class="banner" :src="product.image" />
    </div>
    <!-- package-title -->
    <div class="package-title">
      <h2>{{product.name}}</h2>
      <h3>{{product.brief}}</h3>
    </div>
    <!-- 验证表单 -->
    <div class="vail-form">
      <div class="vail-group">
        <h5>用户名</h5>
        <input v-model="name" type="text" placeholder="请输入用户名" />
      </div>
      <!--  -->
      <div class="vail-group">
        <h5>密码</h5>
        <input v-model="phone" type="text" placeholder="请输入密码" />
      </div>

      <a v-if="is_snapshot" class="beginCeping" @click="get_userinfo()">微信登录</a>
      <a v-else class="beginCeping" @click="checkCeping()">开始测评</a>
      
    </div>
  </div>
</template>

<script>
import { check,goods_detail } from "@/api/measurement_system";
import { phoneValidation } from "@u/validation";
import { getStorage, setStorage, goAuthLogin } from "@/utils/tools";

export default {
  data() {
    return {
      bodyShow: false,
      product:{},
      list: [],
      data:{},
      name:'',
      phone:null,
      is_snapshot: true
    }
  },

  mounted() {
      let name = getStorage(this.$route.path, 'name');
      let phone = getStorage(this.$route.path, 'phone');

      if(name && phone) {
        this.name = name;
        this.phone = phone;
      }
  },

  methods: {
    get_userinfo() {
      goAuthLogin('微信登录获取头像昵称', null, 'snsapi_userinfo');
    },
    /*
     *@param:
     *@return:
     *@Description: 验证测评
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020-7-30 10:10:54
     */
    checkCeping(){
      if(!this.name || !this.phone){
        this.$toast('用户名或密码不能为空！');
        return
      }

      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      check({
        product_id: this.$route.query.id,
        name: this.name,
        phone: this.phone
      }).then(data => {
        if(data.code=='10002'){
          this.$toast(data.data.msg);
          return
        }

        setStorage(this.$route.path, 'name', this.name);
        setStorage(this.$route.path, 'phone', this.phone);

        this.$toast.clear();
        if(this.product.type == 1) {
          this.$router.push(this.product.link);
        } else {
          this.$router.push({
              path:'/ms_package_goods',
              query:{
                  id: this.$route.query.id,
                  hide_payment: 1
              }
          });
        }
      });

    },
    /*
     *@param:
     *@return:
     *@Description: 初始化数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020-7-29 15:10:54
     */
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      goods_detail({
        id: this.$route.query.id
      }).then(data => {
        if(data.code=='10002'){
          this.$toast(data.data.msg);
          return
        }
        this.data = data;
        this.is_snapshot = data.is_snapshot;
        this.product = data.product;
        document.title = this.product.name;
        this.list = data.list;
        this.bodyShow = true;
        this.$toast.clear();
      });

      
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.vail-form{
  padding:60px 50px;
  background-color:#ffffff;
  .vail-group{
    font-size:26px;
    color:#333333;
    margin-bottom:50px;
    h5{
      font-size:30px;
      margin-bottom:15px;
    }
    input{
      line-height: 70px;
      border-radius:8px;
      border: 2px solid #cccccc;
      width:100%;
      padding-left:15px;
    }
  }
  .beginCeping{
    display:block;
    width:300px;
    margin:0 auto;
    background-color:#eb5032;
    color:#ffffff;
    border-radius:15px;
    text-align:center;
    line-height:70px;
    font-size: 32px;
  }
}

.Package-goods {
  background-color: #f0f0f0;
  .header {
    position: relative;
    font-size: 0;
    .banner {
      max-width: 750px;
      width: 100%;
      height: 400px;
    }
    ul.text {
      position: absolute;
      bottom: -2px;
      left: 0;
      height: 62px;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 0 38px;
      background: rgba(255, 255, 255, 0.5);
      li {
        font-size: 22px;
        height: 100%;
        display: flex;
        align-items: center;
        span {
          font-size: 30px;
          font-weight: 400;
          margin-right: 5px;
        }
      }
    }
  }
  .package-title {
    padding: 30px;
    text-align: center;
    background-color: #ffffff;
    margin-bottom: 40px;
    h2 {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 20px;
    }
    h3 {
      font-size: 24px;
      color: #666666;
      margin-bottom: 28px;
    }
    h4 {
      span {
        font-size: 32px;
        color: #eb5032;
        margin-right: 10px;
      }
      del {
        font-size: 22px;
        color: #666666;
      }
      sup {
        font-size: 22px;
        color: #eb5032;
        margin-right: 5px;
      }
    }
  }
  .van-popup{
    background-color: transparent;
  }
}


</style>
<style lang="scss" >
.Package-goods .package-list{
  .list-content {
    padding: 30px;
    img {
      width: 100%;
    }
  }
}
</style>